module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_order_nomber-7343e2aa47cb311788c645484763e7ff.png";